type Storage = { get: () => string | undefined; set: (value: string) => void }

type Save = (subscription: PushSubscription) => Promise<void>

const identityFor = (subscription: PushSubscription, installationId: string) => {
  const keys = subscription.toJSON().keys
  return JSON.stringify([subscription.endpoint, keys?.p256dh ?? "", keys?.auth ?? "", installationId])
}

export const createPushSubscriptionSynchronizer = (save: Save) => {
  const pending = new Map<string, Promise<void>>()

  return (subscription: PushSubscription, installationId: string | undefined, storage: Storage) => {
    if (!installationId) return save(subscription)
    const identity = identityFor(subscription, installationId)
    try {
      if (storage.get() === identity) return Promise.resolve()
    } catch {}
    const existing = pending.get(identity)
    if (existing) return existing
    const operation = save(subscription)
      .then(() => {
        try { storage.set(identity) } catch {}
      })
      .finally(() => pending.delete(identity))
    pending.set(identity, operation)
    return operation
  }
}
